import { useMemo } from "react";
import type { Participant, SuggestedParticipants } from "@/types";

export function useUnclaimedSuggestions(
  suggestedParticipants?: SuggestedParticipants,
  participants?: Partial<Participant>[],
) {
  const unclaimedSuggestions = useMemo(() => {
    if (!suggestedParticipants || !participants) return [];

    return suggestedParticipants.filter((suggestion) => {
      if (!suggestion.clientId && !suggestion.userId) return false;

      if (suggestion.clientId) {
        return !participants.some((p) => p.clientId === suggestion.clientId);
      }
      if (suggestion.userId) {
        return !participants.some((p) => p.userId === suggestion.userId);
      }
      return false;
    });
  }, [suggestedParticipants, participants]);

  const excludedClientIds = useMemo(() => {
    return unclaimedSuggestions
      .map((s) => s.clientId)
      .filter((id): id is string => !!id);
  }, [unclaimedSuggestions]);

  const excludedUserIds = useMemo(() => {
    return unclaimedSuggestions
      .map((s) => s.userId)
      .filter((id): id is string => !!id);
  }, [unclaimedSuggestions]);

  return { unclaimedSuggestions, excludedClientIds, excludedUserIds };
}
